import { useRef } from 'react';
import { useParams } from 'react-router-dom';

const PrintPdf: React.FC = () => {
    const params: { fileName: string } = useParams();

    const ref = useRef<HTMLIFrameElement>(null);

    if (!params.fileName) {
        window.close();
        return null;
    }

    const onLoad = () => {
        if (ref.current?.contentWindow) {
            console.log('cool');
            ref.current.contentWindow.onafterprint = () => {
                console.log('fdsfs');
                window.close();
            };

            ref.current.contentWindow.onbeforeunload = () => {
                console.log('fdsfs');
                window.close();
            };
        }

        ref.current?.contentWindow?.print();
    };

    return (
        <div className="flex flex-col items-center justify-center w-screen h-screen space-y-64">
            <div className="pulse">
                <svg width="16px" height="12px">
                    <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                    <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                </svg>
            </div>
            <p className="text-24 text-neutral-black">Setting up workspace...</p>
            <iframe
                style={{ width: 1, height: 1, position: 'absolute' }}
                // className="w-full h-full"
                ref={ref}
                onLoad={onLoad}
                onError={() => window.close()}
                src={`/proxy/pdf/${params.fileName}`}
            />
        </div>
    );
};

export default PrintPdf;
